import { render, staticRenderFns } from "./pie.md?vue&type=template&id=3a57429d&"
import script from "./pie.md?vue&type=script&lang=js&"
export * from "./pie.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a57429d')) {
      api.createRecord('3a57429d', component.options)
    } else {
      api.reload('3a57429d', component.options)
    }
    module.hot.accept("./pie.md?vue&type=template&id=3a57429d&", function () {
      api.rerender('3a57429d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Pie/pie.md"
export default component.exports